module.exports = __webpack_public_path__ + "img/UserInterests.bb98294d.svg";